import { DewiAuctionCard } from '@components/DewiAuctionCard'
import { useMediaQuery } from '@mui/material'
import { StaticImageData } from 'next/image'
import { useMemo } from 'react'

const DEFAULT_TRAITS = [
  {
    trait_type: 'Background',
    value: '????',
  },
  {
    trait_type: 'Body',
    value: '????',
  },
  {
    trait_type: 'Eyes',
    value: '????',
  },
  {
    trait_type: 'Nose',
    value: '????',
  },
  {
    trait_type: 'Ears',
    value: '????',
  },
]

type AuctionDisplayProps = {
  image: string | StaticImageData
  traitsArray: { value: string; trait_type: string }[]
}

export const AuctionDisplay = ({ traitsArray, image }: AuctionDisplayProps) => {
  const isMobile = useMediaQuery('(max-width: 1024px)')

  const actualTraits = useMemo(() => {
    if (!traitsArray || traitsArray === null || traitsArray.length < 2) {
      return DEFAULT_TRAITS
    }

    return traitsArray
  }, [traitsArray])

  return (
    <div className="rounded-l-xl lg:h-[43rem] w-full lg:w-[40rem] overflow-hidden">
      <div
        className="flex w-full justify-center items-center flex-wrap lg:justify-start lg:items-start lg:gap-4 lg:w-fit lg:-ml-12 lg:-top-96 lg:h-fit relative xs:p-8 xs:pt-0 lg:p-0"
        style={{ transform: isMobile ? 'rotate(0deg)' : 'rotate(-12deg)' }}
      >
        <DewiAuctionCard
          className="-mt-4 hidden lg:flex"
          placeholder
          invisible
        />
        <DewiAuctionCard className="hidden lg:flex" placeholder invisible />
        <DewiAuctionCard
          className="-mt-8 hidden lg:flex"
          invisible
          image={image}
          traits={actualTraits}
        />
        <DewiAuctionCard traits={actualTraits} image={image} />
        <DewiAuctionCard
          className="-mt-9 hidden lg:flex"
          placeholder
          invisible
        />
        <DewiAuctionCard className="hidden lg:flex" placeholder invisible />
      </div>
    </div>
  )
}
